import { CopyIcon } from 'lucide-react'

// Marks a cycle as a repeat of an earlier page range. Shared by the period card and the review page.
export const DuplicateBadge = () => (
  <span className="inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700">
    <CopyIcon className="size-3" />
    Duplicate
  </span>
)
